import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {black500, blue50, greyishBlue100, greyishBlue600, primaryColor} from "assets/jss/main";

import {ErasureRequestedChip, EscalationChips, ExpiryChip, HolderChip, SuspendedChip} from "./StatusChips";
import StatusChip from "./StatusChip";
import {formatRelative} from "./formatters";

ConversationCard.propTypes = {
    conversation: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    memberEmail: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
};

/**
 * One row of the list: who, where the conversation stands, what was said last and when.
 */
function ConversationCard({conversation, selected, memberEmail, onSelect}) {
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => window.getSelection().toString().length === 0 && onSelect(conversation.id)}
            onKeyDown={(event) => event.key === "Enter" && onSelect(conversation.id)}
            style={{
                padding: "10px 12px",
                borderBottom: `1px solid ${greyishBlue100}`,
                borderLeft: `3px solid ${selected ? primaryColor : "transparent"}`,
                backgroundColor: selected ? blue50 : "#ffffff",
                cursor: "pointer",
            }}
        >
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: "8px"}}>
                <div style={{fontWeight: 600, color: black500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                    {conversation.profileName || <FormattedMessage id="personalShopper.customer.anonymous" />}
                </div>
                <div style={{color: greyishBlue600, fontSize: "11px", whiteSpace: "nowrap"}}>{formatRelative(conversation.lastMessageAt)}</div>
            </div>
            <div style={{color: greyishBlue600, fontSize: "12px"}}>{conversation.phone}</div>
            {conversation.lastMessage && (
                <div style={{fontSize: "13px", marginTop: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                    <span style={{color: greyishBlue600}}>
                        <FormattedMessage id={`personalShopper.author.${conversation.lastMessage.author}`} />{" : "}
                    </span>
                    {conversation.lastMessage.content}
                </div>
            )}
            <div style={{display: "flex", gap: "4px", flexWrap: "wrap", marginTop: "6px"}}>
                <StatusChip status={conversation.status} />
                {conversation.handledBy && <HolderChip handledBy={conversation.handledBy} memberEmail={memberEmail} />}
                <EscalationChips categories={conversation.openEscalations} />
                <SuspendedChip suspendedAt={conversation.suspendedAt} suspensionReason={conversation.suspensionReason} />
                <ErasureRequestedChip erasureRequestedAt={conversation.erasureRequestedAt} />
                <ExpiryChip retention={conversation.retention} />
            </div>
            {conversation.awaitingHuman && (
                <div style={{color: greyishBlue600, fontSize: "11px", marginTop: "4px"}}>
                    <FormattedMessage id="personalShopper.list.awaitingSince" values={{since: formatRelative(conversation.lastInboundAt)}} />
                </div>
            )}
        </div>
    );
}

export default ConversationCard;
